import './index.css';
import { bool, func, string } from 'prop-types';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
const YEAR = (new Date()).getFullYear();
const YEARS = Array.from(new Array(100), (val, index) => YEAR - index);
const MONTHS = Array.from(new Array(12), (val, index) => (index + 1).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
}));
const DatePicker = (props) => {
    DatePicker.propTypes = {
        name: string,
        placeholder: string,
        isRequired: bool,
        currentValue: string,
        setCurrentValue: func,
    };
    const { name, placeholder, isRequired, currentValue, setCurrentValue } = props;
    const [formValues, setFormValues] = useState(currentValue
        ? [currentValue.substring(0, 4), currentValue.substring(5, 7)]
        : ['', '']);
    const handleDateChange = (value, type) => {
        let newValues;
        if (type === 'year') {
            newValues = [value, formValues[1]];
        }
        else if (type === 'month') {
            newValues = [formValues[0], value];
        }
        setFormValues(newValues);
        if (setCurrentValue.length === 1) {
            if (newValues[0] !== '' && newValues[1] !== '') {
                setCurrentValue(newValues[0] + '-' + newValues[1]);
            }
            else
                setCurrentValue(undefined);
        }
        else if (setCurrentValue.length === 2) {
            if (newValues[0] !== '' && newValues[1] !== '') {
                setCurrentValue(name, newValues[0] + '-' + newValues[1]);
            }
            else
                setCurrentValue(name, '');
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Form.Control, { className: 'form-dropdown-inline', as: 'select', name: name, id: 'radio-date-picker1', placeholder: placeholder, value: formValues[0], onChange: e => handleDateChange(e.target.value, 'year'), required: isRequired },
            React.createElement("option", null),
            YEARS.map((year, key) => React.createElement("option", { key: key }, year))),
        React.createElement(Form.Control, { className: 'form-dropdown-inline', as: 'select', name: name, id: 'radio-date-picker2', placeholder: placeholder, value: formValues[1], onChange: e => handleDateChange(e.target.value, 'month'), required: isRequired },
            React.createElement("option", null),
            MONTHS.map((month, key) => React.createElement("option", { key: key }, month))),
        React.createElement(Form.Control.Feedback, { type: 'invalid' }, "Please provide a value")));
};
export default DatePicker;
